import { Stack } from "@mui/material";
import { HazardCategoryPicker } from "components/Forms/HazardCategoryPicker";
import { HazardType } from "generated-graphql/graphql";
import { Control } from "react-hook-form";

import { ChemicalDetailInputs } from ".";

export function HazardCategorySection({ control }: { control: Control<ChemicalDetailInputs> }) {
  return (
    <Stack spacing={2}>
      <Stack spacing={2} direction={{ xs: "column", md: "row" }}>
        <HazardCategoryPicker
          name="physicalHazardCategoryCodes"
          control={control}
          hazardType={HazardType.Physical}
          label="Physical Hazards"
        />
        <HazardCategoryPicker
          name="healthHazardCategoryCodes"
          control={control}
          hazardType={HazardType.Health}
          label="Health Hazards"
        />
      </Stack>
    </Stack>
  );
}
